import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserSproutsRedeemed = () => {
    const { reportData } = useContext(ReportContext);

    const reportDataRedeemedOnly =
        reportData
            ?.filter((x) => x.sprouts < 0)
            .map((x) => ({ ...x, sprouts: x.sprouts * -1 })) || [];

    const columns = [
        ...userColumns,
        { field: 'sproutsDatetime', name: 'Date ({tz} time zone)', dataType: 'datetime' },
        { field: 'sprouts', name: 'Sprouts Spent', dataType: 'numeric' },
        { field: 'entries', name: 'Entries Redeemed', dataType: 'numeric' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const filteredDataEarnedOnly = filteredData.filter((row) => row.sprouts > 0);
    // const filteredDataRedeemedOnly = filteredData.filter((row) => row.sprouts < 0);

    // const rolledUpEarnedOnly = dataRollUp(
    //     filteredDataEarnedOnly,
    //     (row) => formatDateToIsoExtDate(row.sproutsDatetime),
    //     {
    //         sumFields: ['sprouts'],
    //     }
    // );
    // const rolledUpRedeemedOnly = dataRollUp(
    //     filteredDataRedeemedOnly,
    //     (row) => formatDateToIsoExtDate(row.sproutsDatetime),
    //     {
    //         sumFields: ['sprouts'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Sprouts Earned',
    //         x: rolledUpEarnedOnly.map((x) => x.groupByField),
    //         y: rolledUpEarnedOnly.map((x) => x.sproutsSum),
    //     },
    //     {
    //         name: 'Sprouts Redeemed',
    //         x: rolledUpRedeemedOnly.map((x) => x.groupByField),
    //         y: rolledUpRedeemedOnly.map((x) => x.sproutsSum * -1),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportDataRedeemedOnly}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="Sprouts Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows transactions where users redeemed their Sprouts for
                    raffle entries. Entries are purchased in specific amounts of 25
                    sprouts for 1 entry, 220 sprouts for 10 entries, 500 sprouts for 25
                    entries, and 900 sprouts for 50 entries. Each row represents a
                    redemption transaction.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Date">
                    When the Sprouts redemption transaction occurred.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Sprouts Spent">
                    The number of Sprouts the user spent in this transaction.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Entries Redeemed">
                    The number of entries this bought the user into our monthly
                    sweepstakes. Entries only count towards the sweepstakes for the month
                    in which they are bought.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserSproutsRedeemed;
